import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Table, Space, PageHeader, Button, Modal, notification } from "antd";
//import { reverse } from "named-urls";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { companyPickupAddressSaga } from "./saga";
import * as selectors from "./selectors";
//import routes from "../../../../../routes";
import { addressToString } from "../../../../utils/formatter";
import AddAddressForm from "../../../../forms/AddAddressForm";
import addressSchema from "../../../../schemas/addressSchema";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../../../contexts/auth";

const STORAGE_KEY = 'companyPickupAddressFilters';

const CompanyPickupAddressListing = () => {
  const auth = useAuth();
  const user = auth.loggedInUser;
  const userRole = user.role;
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: companyPickupAddressSaga });
  const dispatch = useDispatch();
  const { companyId } = useParams();
  //const history = useHistory();

  const companyDetails = useSelector(selectors.selectCompanyDetails) || {};
  const countries = useSelector(selectors.selectCountries);
  const states = useSelector(selectors.selectStates);
  const cities = useSelector(selectors.selectCities);
  const pickupAddress =
    useSelector(selectors.selectCompanyPickupAddreses) || [];
  const totalPickupAddress = useSelector(selectors.selectTotalAddresses) || [];
  const addressCount = useSelector(selectors.selectAddressCount);
  const loading = useSelector(selectors.selectLoading);
  const getInitialState = () => {
    try {
      const saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved) {
        const parsedState = JSON.parse(saved);
        if (parsedState.companyId === companyId) {
          return parsedState;
        }
      }
    } catch (e) {
      console.error('Failed to parse saved filters:', e);
    }
    
    return {
      currentPage: 1,
      filters: {},
      companyId: companyId,
    };
  };

  const initialState = getInitialState();

  const [addPickupAddressModalVisbile, setAddPickupAddressModalVisible] =
    useState(false);
  const [editPickupAddressModalVisible, setEditPickupAddressModalVisible] =
    useState(false);
  const [addressForEdit, setAddressForEdit] = useState({});
  const [triggerReload, setTriggerReload] = useState(false);
  const [currentPage, setCurrentPage] = useState(initialState.currentPage);
  const [filters, setFilters] = useState(initialState.filters);
  useEffect(() => {
    const state = {
      currentPage,
      filters,
      companyId: companyId,
    };
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      console.error('Failed to save filters:', e);
    }
  }, [currentPage, filters, companyId]);

  useEffect(() => {
    let query = `page=${currentPage}&limit=10`;
    
    if (filters.address && filters.address.length > 0) {
      let addresses = "";
      let count = 0;
      filters.address.forEach((add) => {
        addresses = addresses + add.split(",")[0];
        count = count + 1;
        if (filters.address.length !== count) addresses = addresses + ",";
      });
      query = `addressLine1=${addresses}&search=true`;
    }

    dispatch(actions.fetchCompanyPickupAddress({ id: companyId, query }));
    dispatch(actions.fetchTotalPickupAddresses({ id: companyId }));
    dispatch(actions.fetchCompanyDetails({ id: companyId }));
    dispatch(actions.fetchCountries());
    return () => {
      dispatch(actions.initializeState());
    };
  }, [dispatch, companyId, triggerReload, currentPage, filters]);

  const tableData = [
    ...[...pickupAddress].map((add) => ({
      formattedAddress: addressToString(add),
      address: {
        id: add?._id,
        addressLine1: add?.addressLine1,
        addressLine2: add?.addressLine2,
        city: add?.city?._id,
        country: add?.country?._id,
        state: add?.state?._id,
        pincode: add?.pincode,
      },
    })),
  ];

  const handleTablePagination = (pagination, filters, sorter) => {
    setCurrentPage(pagination.current);
    setFilters({
      address: filters.address || null,
    });
    let query = `page=${pagination.current}&limit=10`;
    if (filters.address) {
      let addresses = "";
      let count = 0;
      filters.address.forEach((add) => {
        addresses = addresses + add.split(",")[0];
        count = count + 1;
        if (filters.address.length !== count) addresses = addresses + ",";
      });

      query = `addressLine1=${addresses}&search=true`;
    }

    dispatch(actions.fetchCompanyPickupAddress({ id: companyId, query }));
  };

  const {
    control,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      type: "pickup",
      addressLine1: "",
      addressLine2: "",
      district: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      landmark: "",
    },
    resolver: yupResolver(addressSchema),
  });

  const resetAddress = () => {
    reset({
      type: "pickup",
      addressLine1: "",
      addressLine2: "",
      district: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      landmark: "",
    });
  };
  useEffect(() => {
    if (editPickupAddressModalVisible) {
      reset(addressForEdit.address);
    } else {
      reset({
        type: "pickup",
        addressLine1: "",
        addressLine2: "",
        district: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
        landmark: "",
      });
    }
  }, [reset, editPickupAddressModalVisible, addressForEdit]);

  const selectedCountry = watch("country");
  const selectedState = watch("state");

  useEffect(() => {
    if (selectedCountry) {
      dispatch(actions.fetchStates({ countryId: selectedCountry }));
    }
  }, [selectedCountry, dispatch]);

  useEffect(() => {
    if (selectedState)
      dispatch(actions.fetchCities({ stateId: selectedState }));
  }, [selectedState, dispatch]);

  /*  const handleBack = () => {
    history.push(routes.backOffice.addresses);
    // history.goBack();
  }; */

  const onSubmitAddPickupAddress = (data) => {
    data.company = companyDetails._id;
    setAddPickupAddressModalVisible(false);
    dispatch(
      actions.addPickupAddress({
        data,
        onSuccess: () => {
          notification.success({
            message: "Pickup Address added successfully!!!",
          });
          setTriggerReload(!triggerReload);
        },
        onFailure: () => {
          notification.error({
            message: "There was some error while adding Pickup Address",
          });
        },
      })
    );
    resetAddress();
  };

  const onSubmitEditPickupAddress = (data) => {
    data.company = companyDetails._id;
    setEditPickupAddressModalVisible(false);
    dispatch(
      actions.updatePickupAddress({
        data: data,
        id: addressForEdit.address.id,
        onSuccess: () => {
          notification.success({
            message: "Pickup Address updated successfully!!!",
          });
          setTriggerReload(!triggerReload);
        },
        onFailure: () => {
          notification.error({
            message: "There was some error while updating Pickup Address",
          });
        },
      })
    );
  };

  const handleAddCancel = () => {
    setAddPickupAddressModalVisible(false);
    resetAddress();
  };
  const handleEditCancel = () => {
    setEditPickupAddressModalVisible(false);
  };
  const getAddressFilters = () => {
    if (!totalPickupAddress?.length) return [];
    const filter = totalPickupAddress.map((add) => ({
      text: addressToString(add),
      value: addressToString(add),
    }));
    return filter;
  };
  const columns = [
    {
      title: "Address",
      dataIndex: "formattedAddress",
      key: "address",
      filters: getAddressFilters(),
      filteredValue: filters.address || null,
      filterSearch: true,
    },
    ...(userRole !== "support_team"
      ? [
          {
            title: "Action",
            key: "action",
            render: (text, record) => (
              <Space size="middle">
                <Button
                  onClick={() => {
                    setAddressForEdit(record);
                    setEditPickupAddressModalVisible(true);
                  }}
                >
                  Edit
                </Button>
              </Space>
            ),
          },
        ]
      : []),
  ];

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        //onBack={handleBack}
        ghost={false}
        title="Pickup Addresses"
        subTitle={companyDetails.companyName}
        extra={[
          userRole !== "support_team" && (
            <Button
              key="1"
              type="primary"
              onClick={() => {
                setAddPickupAddressModalVisible(true);
              }}
            >
              Add Pickup Address
            </Button>
          )
        ]}
      />
      <div
        style={{
          height: "calc(100vh - 137px)",
          overflowY: "auto",
          padding: 24,
        }}
      >
        <Table
          columns={columns}
          dataSource={tableData}
          loading={loading}
          pagination={{
            current: currentPage,
            pageSize: 10,
            total: addressCount,
            showSizeChanger: false,
            disabled: tableData.length === 0 ? true : false,
          }}
          onChange={handleTablePagination}
        >
          {/*      <Column
            title="Address"
            dataIndex="formattedAddress"
            key="address"
            filters={getAddressFilters()}
            filterSearch={true}
          />
          <Column
            title="Action"
            key="action"
            render={(text, record) => (
              <Space size="middle">
                <Button
                  onClick={() => {
                    setAddressForEdit(record);
                    setEditPickupAddressModalVisible(true);
                  }}
                >
                  Edit
                </Button>
              </Space>
            )}
          /> */}
        </Table>
      </div>
      <Modal
        title="Add Pickup Address"
        visible={addPickupAddressModalVisbile}
        centered
        onOk={handleSubmit(onSubmitAddPickupAddress)}
        onCancel={handleAddCancel}
        okText="Save"
        check={false}
      >
        <AddAddressForm
          errors={errors}
          control={control}
          watch={watch}
          options={{ countries, states, cities }}
          check={false}
          setValue={setValue}
        />
      </Modal>
      <Modal
        title="Edit Pickup Address"
        visible={editPickupAddressModalVisible}
        centered
        onOk={handleSubmit(onSubmitEditPickupAddress)}
        onCancel={handleEditCancel}
        okText="Save"
        check={false}
      >
        <AddAddressForm
          errors={errors}
          control={control}
          watch={watch}
          options={{ countries, states, cities }}
          check={false}
          setValue={setValue}
        />
      </Modal>
    </div>
  );
};

export default CompanyPickupAddressListing;
